import { flightModeStyle } from './style'

export const TimeZoneControl = ({ onChange, value, log }) => {
  const timezones = Intl.supportedValuesOf('timeZone')


  const handleChange = (val) => {
    if(log)
      console.log('TimeZoneControl', val)

    if(onChange)
      onChange(val)
  }

  return (
    <select style={flightModeStyle.input} onChange={e => handleChange(e.target.value)} value={value}>
      {timezones.map((z, idx) => (<option key={idx}>{z}</option>))}
    </select>
  )
}

